import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_BACKENDSERVICE_BASEURL,
  withCredentials: true,
  timeout: 60000,
  headers: {
    Accept: 'application/json',
  },
});

export default {
  checkStatus(loggedIn, db, tiktokDb) {
    return apiClient.post('/status', { loggedIn, db, tiktokDb }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  checkStatus2(hostId, tikokHostId, userid, instanz, isBeta) {
    return apiClient.post('/status2', {
      hostId, tikokHostId, userid, instanz, isBeta,
    }, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  },
  login(username, password) {
    return apiClient.post('/authenticate', { username, password }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  logout() {
    return apiClient.get('/logout');
  },
  loadCommand(variant) {
    return apiClient.post('/getCommands', { variant }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  saveCommand(data) {
    return apiClient.post('/saveCommand', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadCustomCommand(variant) {
    return apiClient.post('/getCustomCommands', { variant }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  saveCustomCommand(data) {
    return apiClient.post('/saveCustomCommand', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  insertCustomCommand(data) {
    return apiClient.post('/insertCustomCommand', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  deleteCustomCommand(data) {
    return apiClient.post('/deleteCustomCommand', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadCommandCounters(data) {
    return apiClient.post('/getCommandCounters', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  saveCommandCounter(data) {
    return apiClient.post('/saveCommandCounter', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  deleteCommandCounter(data) {
    return apiClient.post('/deleteCommandCounter', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadCommandSettings(data) {
    return apiClient.post('/getCommandSettings', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  saveCommandSettings(data) {
    return apiClient.post('/saveCommandSettings', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadSubathonTimerSettings() {
    return apiClient.get('/getSubathonTimerSettings', { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  saveSubathonTimerSettings(data) {
    return apiClient.post('/saveSubathonTimerSettings', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadGiveaways() {
    return apiClient.get('/getGiveaways');
  },
  saveGiveaway(data) {
    return apiClient.post('/saveGiveaway', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  saveGiveawayNoPoints(data) {
    return apiClient.post('/saveGiveawayNoPoints', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  deleteGiveaway(data) {
    return apiClient.post('/deleteGiveaway', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  startGiveaway(data) {
    return apiClient.post('/startGiveaway', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  startGiveawayNoPoints(data) {
    return apiClient.post('/startGiveawayNoPoints', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  stopGiveaway(data) {
    return apiClient.post('/stopGiveaway', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  stopGiveawayNoPoints(data) {
    return apiClient.post('/stopGiveawayNoPoints', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  saveSwitchStateCommands(data) {
    return apiClient.post('/saveSwitchStateCommands', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  saveSwitchStateCCommands(data) {
    return apiClient.post('/saveSwitchStateCCommands', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  saveVisibleStateCommands(data) {
    return apiClient.post('/saveVisibleStateCommands', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  saveLoyalitySettings(data) {
    return apiClient.post('/saveLoyalitySettings', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadLoyalitySettings(variant) {
    return apiClient.post('/loadLoyalitySettings', { variant }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadSingleGiveaway(id) {
    return apiClient.post('/loadSingleGiveaway', { id }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  pickWinnerGiveaway(data) {
    return apiClient.post('/pickWinnerGiveaway', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadCommandList(pubId) {
    return apiClient.post('/commandlist', { pubId }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  getInstanzByPubId(pubId) {
    return apiClient.post('/getInstanzByPubId', { pubId }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loginWithCode(code) {
    return apiClient.post('/loginWithCode', { code }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadRewards() {
    return apiClient.get('/loadRewards');
  },
  loadGiveawaysNoPoints() {
    return apiClient.get('/loadGiveawaysNoPoints');
  },
  saveSwitchStateCp(data) {
    return apiClient.post('/saveSwitchStateCp', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  updateReward(data) {
    return apiClient.post('/updateReward', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  createReward(data) {
    return apiClient.post('/createReward', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  deleteReward(data) {
    return apiClient.post('/deleteReward', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  ticketbuy(data) {
    return apiClient.post('/ticketbuy', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadOverlays() {
    return apiClient.get('/overlays');
  },
  saveOverlay(data) {
    return apiClient.post('/saveOverlay', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  createOverlay(data) {
    return apiClient.post('/createoverlay', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  checkBotId(data) {
    return apiClient.post('/checkBotId', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  selectHostId(data) {
    return apiClient.post('/checkBotId', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  pullOptions(code, state, isBeta) {
    return apiClient.post('/pullOptions', { code, state, isBeta }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadGiveawayNoPointsEntrant(data) {
    return apiClient.post('/loadGiveawayNoPointsEntrant', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  pickWinnerGiveawayNoPoints(data) {
    return apiClient.post('/pickWinnerGiveawayNoPoints', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  lastWinnerGiveawayNoPoints(data) {
    return apiClient.post('/lastWinnerGiveawayNoPoints', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  deleteGiveawayNoPoints(data) {
    return apiClient.post('/deleteGiveawayNoPoints', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  deleteGiveawayNoPointsUser(data) {
    return apiClient.post('/deleteGiveawayNoPointsUser', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadOverlay(id) {
    return apiClient.get(`/overlay/${id}`);
  },
  deleteOverlay(id) {
    return apiClient.get(`/deleteOverlay/${id}`);
  },
  loadOverlaySizes() {
    return apiClient.get('/getOverlaySizes');
  },
  loadSubGoals(id) {
    return apiClient.get(`/loadsubgoals/${id}`);
  },
  loadBitGoals(id) {
    return apiClient.get(`/loadbitgoals/${id}`);
  },
  loadTopDono(id) {
    return apiClient.get(`/loadtopdono/${id}`);
  },
  loadObsToken(data) {
    return apiClient.post('/loadObsToken', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadCMD_PubID(data) {
    return apiClient.post('/loadCMD_PubID', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  savePrefix(data) {
    return apiClient.post('/savePrefix', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadPools() {
    return apiClient.get('/loadPools');
  },
  createPool(data) {
    return apiClient.post('/createPool', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  savePoolContent(editedItem, filteredContent) {
    return apiClient.post('/savePoolContent', { editedItem, filteredContent }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  savePoolSettings(data) {
    return apiClient.post('/savePoolSettings', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadLoyaltiyRewards() {
    return apiClient.get('/loadLoyaltiyRewards');
  },
  updateLoyaltiyReward(data) {
    return apiClient.post('/updateLoyaltiyReward', data, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  createLoyaltiyReward(data) {
    return apiClient.post('/createLoyaltiyReward', data, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  deleteLoyaltiyReward(data) {
    return apiClient.post('/deleteLoyaltiyReward', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadUserSounds() {
    return apiClient.get('/loadUserSounds');
  },
  updateUserSound(data) {
    return apiClient.post('/updateUserSound', data, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  createUserSound(data) {
    return apiClient.post('/createUserSound', data, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  deleteUserSound(data) {
    return apiClient.post('/deleteUserSound', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  testUserSound(data) {
    return apiClient.post('/testUserSound', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadRewardsPublic(data) {
    return apiClient.post('/loadRewardsPublic', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  redeemRewardsPublic(data) {
    return apiClient.post('/redeemRewardsPublic', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadPointCreditLog(data) {
    return apiClient.post('/loadPointCreditLog', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadRewardRequests() {
    return apiClient.get('/loadRewardRequests');
  },
  loadRewardRequestsHistory() {
    return apiClient.get('/loadRewardRequestsHistory');
  },
  acceptRewardRequests(data) {
    return apiClient.post('/acceptRewardRequests', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  cancelRewardRequests(data) {
    return apiClient.post('/cancelRewardRequests', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  acceptallRewardRequests(data) {
    return apiClient.post('/acceptallRewardRequests', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  cancelallRewardRequests(data) {
    return apiClient.post('/cancelallRewardRequests', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  deletePool(data) {
    return apiClient.post('/deletePool', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadProfilSettings(data) {
    return apiClient.post('/loadProfilSettings', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  saveProfilSettings(data) {
    return apiClient.post('/saveProfilSettings', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  createBot(data) {
    return apiClient.post('/createBot', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  sendPaymentConfirmation(data) {
    return apiClient.post('/sendPaymentConfirmation', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  devCreateOnboardingSession(data) {
    return apiClient.post('/devCreateOnboardingSession', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  getDevModeStatus() {
    return apiClient.get('/devModeStatus');
  },
  getSubscriptionStep(id) {
    return apiClient.get(`/subscriptionstep/${id}`);
  },
  createSubscription(data) {
    return apiClient.post('/createSubscription', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  checkSpotifyDevice(data) {
    return apiClient.post('/checkSpotifyDevice', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  checkTwitchUser(data) {
    return apiClient.post('/checkTwitchUser', { name: data }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadBotStateData() {
    return apiClient.get('/botStateData');
  },
  updateRefreshToken(data) {
    return apiClient.post('/updateRefreshToken', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  restartBot() {
    return apiClient.get('/restartBot');
  },
  checkRefreshToken() {
    return apiClient.get('/checkRefreshToken');
  },
  loadBotEventSubStatus() {
    return apiClient.get('/botEventSubStatus');
  },
  saveMonthlySettings(data) {
    return apiClient.post('/saveMonthlySettings', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadMonthlySettings(variant) {
    return apiClient.post('/loadMonthlySettings', { variant }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  saveSwitchStateVariable(data) {
    return apiClient.post('/saveSwitchStateVariable', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadHistoricalData(variant) {
    return apiClient.post('/loadHistoricalData', { variant }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  sendOrderConfirm(data) {
    return apiClient.post('/sendOrderConfirm', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  deleteLayer(data) {
    return apiClient.post('/deleteLayer', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadEquipmentList(data) {
    return apiClient.post('/loadEquipmentList', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  saveEquipment(data) {
    return apiClient.post('/saveEquipment', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  initalEquipmentList(data) {
    return apiClient.post('/initalEquipmentList', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadEquipmentListGlobal() {
    return apiClient.get('/loadEquipmentListGlobal');
  },
  buyEquipment(data) {
    return apiClient.post('/buyEquipment', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadStreamerXPSettings(data) {
    return apiClient.post('/loadStreamerXPSettings', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadExcludedUsers(data) {
    return apiClient.post('/loadExcludedUsers', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  saveExcludedUser(data) {
    return apiClient.post('/saveExcludedUser', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  deleteExcludedUser(data) {
    return apiClient.post('/deleteExcludedUser', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  saveStreamerXP(data) {
    return apiClient.post('/saveStreamerXP', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadRunes(data) {
    return apiClient.post('/loadRunes', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  buyRunes(data) {
    return apiClient.post('/buyRunes', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadRunesGlobal(data) {
    return apiClient.post('/loadRunesGlobal', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadRuneEffects() {
    return apiClient.get('/loadRuneEffects');
  },
  saveRunesGlobal(data) {
    return apiClient.post('/saveRunesGlobal', data, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  createRuneGlobal(data) {
    return apiClient.post('/createRuneGlobal', data, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  deleteRuneGlobal(data) {
    return apiClient.post('/deleteRuneGlobal', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  uploadToMediaLibrary(data) {
    return apiClient.post('/uploadToMediaLibrary', data, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  loadGlobalXPSettings(data) {
    return apiClient.post('/loadGlobalXPSettings', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  saveGlobalXPSettings(data) {
    return apiClient.post('/saveGlobalXPSettings', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadSetup(data) {
    return apiClient.post('/loadSetup', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadSetupVersion(data) {
    return apiClient.post('/loadSetupVersion', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadChangelog(data) {
    return apiClient.post('/loadChangelog', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  connectDiscordBotGuild(data) {
    return apiClient.post('/connectDiscordBotGuild', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  disconnectDiscordGuild(data) {
    return apiClient.post('/disconnectDiscordGuild', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  listDiscordGuilds() {
    return apiClient.get('/listDiscordGuilds');
  },
  selectGuild(data) {
    return apiClient.post('/selectGuild', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  setCommunityGuild(data) {
    return apiClient.post('/setCommunityGuild', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  listLicenses(params) {
    return apiClient.get('/listLicenses', { params });
  },
  createLicense(data) {
    return apiClient.post('/createLicense', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  revokeLicense(data) {
    return apiClient.post('/revokeLicense', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  getChatSenderConfig() {
    return apiClient.get('/getChatSenderConfig');
  },
  saveChatSenderConfig(data) {
    return apiClient.post('/saveChatSenderConfig', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadLiveAnnouncementSettings() {
    return apiClient.get('/loadLiveAnnouncementSettings');
  },
  saveLiveAnnouncementSettings(data) {
    return apiClient.post('/saveLiveAnnouncementSettings', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  sendTestLiveAnnouncement(data) {
    return apiClient.post('/sendTestLiveAnnouncement', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadYoutubeAnnouncementSettings() {
    return apiClient.get('/loadYoutubeAnnouncementSettings');
  },
  saveYoutubeAnnouncementSettings(data) {
    return apiClient.post('/saveYoutubeAnnouncementSettings', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  sendTestYoutubeAnnouncement(data) {
    return apiClient.post('/sendTestYoutubeAnnouncement', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadInstagramAnnouncementSettings() {
    return apiClient.get('/loadInstagramAnnouncementSettings');
  },
  saveInstagramAnnouncementSettings(data) {
    return apiClient.post('/saveInstagramAnnouncementSettings', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  sendTestInstagramAnnouncement(data) {
    return apiClient.post('/sendTestInstagramAnnouncement', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadTicketSystemSettings() {
    return apiClient.get('/loadTicketSystemSettings');
  },
  saveTicketSystemSettings(data) {
    return apiClient.post('/saveTicketSystemSettings', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  createTicketCategories(data) {
    return apiClient.post('/createTicketCategories', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  postTicketMenu() {
    return apiClient.post('/postTicketMenu', {}, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadStreamPlanSettings() {
    return apiClient.get('/loadStreamPlanSettings');
  },
  saveStreamPlanSettings(data) {
    return apiClient.post('/saveStreamPlanSettings', data, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  publishStreamPlan() {
    return apiClient.post('/publishStreamPlan', {}, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadRulesSettings() {
    return apiClient.get('/loadRulesSettings');
  },
  saveRulesSettings(data) {
    return apiClient.post('/saveRulesSettings', data, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  publishRules() {
    return apiClient.post('/publishRules', {}, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadRoleSyncSettings() {
    return apiClient.get('/loadRoleSyncSettings');
  },
  saveRoleSyncSettings(data) {
    return apiClient.post('/saveRoleSyncSettings', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  loadVoiceSettings() {
    return apiClient.get('/loadVoiceSettings');
  },
  saveVoiceSettings(data) {
    return apiClient.post('/saveVoiceSettings', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  addVoiceHub(data) {
    return apiClient.post('/addVoiceHub', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  updateVoiceHub(data) {
    return apiClient.post('/updateVoiceHub', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  deleteVoiceHub(data) {
    return apiClient.post('/deleteVoiceHub', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
};
